import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="py-24 md:py-48 bg-brand-primary relative">
      {/* Tonal separation divider */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-secondary/30 to-transparent"></div>
      
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 lg:gap-40 items-start">
          
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-[11px] tracking-[0.4em] uppercase text-brand-accent font-bold mb-10 block">Get in Touch</span>
            <h2 className="font-display text-5xl md:text-7xl font-light text-white mb-12 tracking-tight leading-[1.05]">
              Let’s begin with the right conversation.
            </h2>
            <p className="text-white text-xl md:text-2xl font-light leading-relaxed mb-20 max-w-md opacity-90">
              Contact EPOQ Assets or choose the business area most relevant to your inquiry.
            </p>
            
            <div className="flex flex-col space-y-8 text-2xl md:text-3xl font-light text-white">
              {['EPOQ Assets', 'Consulting', 'Mobility', 'Capital', 'Learn'].map((item) => (
                <a 
                  key={item} 
                  href={`#${item.toLowerCase().replace('epoq ', '')}`} 
                  className="hover:text-brand-accent transition-all w-fit group flex items-center"
                >
                  <span className="w-0 group-hover:w-10 h-px bg-brand-accent mr-0 group-hover:mr-6 transition-all duration-500"></span>
                  <span className="opacity-80 group-hover:opacity-100 transition-opacity">{item}</span>
                  <FiArrowUpRight className="ml-4 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-500 text-brand-accent" />
                </a>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-brand-primary p-10 md:p-20 border border-brand-secondary/40 shadow-[0_40px_100px_rgba(0,0,0,0.4)] relative overflow-hidden"
          >
            {/* Subtle surface overlay for depth */}
            <div className="absolute inset-0 bg-brand-secondary/5 pointer-events-none"></div>

            <form className="space-y-16 relative z-10" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
                <div className="space-y-6 relative group">
                  <label htmlFor="name" className="text-[12px] tracking-[0.3em] uppercase text-brand-accent font-bold block">Full Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    placeholder="Enter your name"
                    className="w-full bg-transparent border-b-2 border-brand-secondary/40 py-5 text-white placeholder:text-brand-secondary/50 focus:outline-none focus:border-brand-accent transition-all text-xl font-sans"
                  />
                </div>
                <div className="space-y-6 relative group">
                  <label htmlFor="company" className="text-[12px] tracking-[0.3em] uppercase text-brand-accent font-bold block">Company</label>
                  <input 
                    type="text" 
                    id="company" 
                    placeholder="Company name"
                    className="w-full bg-transparent border-b-2 border-brand-secondary/40 py-5 text-white placeholder:text-brand-secondary/50 focus:outline-none focus:border-brand-accent transition-all text-xl font-sans"
                  />
                </div>
              </div>
              
              <div className="space-y-6 relative group">
                <label htmlFor="email" className="text-[12px] tracking-[0.3em] uppercase text-brand-accent font-bold block">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  placeholder="name@company.com"
                  className="w-full bg-transparent border-b-2 border-brand-secondary/40 py-5 text-white placeholder:text-brand-secondary/50 focus:outline-none focus:border-brand-accent transition-all text-xl font-sans"
                />
              </div>

              <div className="space-y-6 relative group">
                <label htmlFor="interest" className="text-[12px] tracking-[0.3em] uppercase text-brand-accent font-bold block">Area of Interest</label>
                <select 
                  id="interest"
                  className="w-full bg-transparent border-b-2 border-brand-secondary/40 py-5 text-white focus:outline-none focus:border-brand-accent transition-all appearance-none cursor-pointer text-xl font-sans"
                >
                  <option value="" className="bg-brand-primary text-brand-light">Select an area...</option>
                  <option value="assets" className="bg-brand-primary">EPOQ Assets</option>
                  <option value="consulting" className="bg-brand-primary">EPOQ Consulting</option>
                  <option value="mobility" className="bg-brand-primary">EPOQ Mobility</option>
                  <option value="capital" className="bg-brand-primary">EPOQ Capital</option>
                  <option value="learn" className="bg-brand-primary">EPOQ Learn</option>
                </select>
              </div>

              <div className="space-y-6 relative group">
                <label htmlFor="message" className="text-[12px] tracking-[0.3em] uppercase text-brand-accent font-bold block">Message</label>
                <textarea 
                  id="message" 
                  rows="6"
                  placeholder="How can we help you?"
                  className="w-full bg-transparent border-b-2 border-brand-secondary/40 py-5 text-white placeholder:text-brand-secondary/50 focus:outline-none focus:border-brand-accent transition-all resize-none text-xl font-sans"
                ></textarea>
              </div>

              <button 
                type="button"
                className="mt-12 px-16 py-7 bg-white text-brand-primary text-[15px] tracking-[0.3em] uppercase font-bold hover:bg-brand-light transition-all duration-500 w-full md:w-auto shadow-2xl transform hover:-translate-y-1"
              >
                Send Inquiry
              </button>
            </form>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Contact;